import { Box, FormControlLabel, Pagination, Stack, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AbsColor } from '../../constants';
import { IRegulation } from '../../contracts/amendment.contract';
import RegulationCardsItem from './regulation-cards-item.component';
import { useAppSelector } from '../../hooks';

interface RegulationCardsProps {
    regulations: IRegulation[];
}

const RegulationCards = ({ regulations }: RegulationCardsProps) => {
    // State for pagination
    const [page, setPage] = useState<number>(0);
    const [pageData, setPageData] = useState<IRegulation[]>([]);
    const rowsPerPage = 10; // Set your desired rows per page
    const userInputText = useAppSelector((state) => state.Vessel.UserSearchQuery);

    const [expandAll, setExpandAll] = useState<boolean>(false);

    // Update paginatedData when page changes
    useEffect(() => {
        // Calculate the start and end indices based on the current page
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;

        // Update the page data based on the calculated indices
        const newPageData = regulations?.slice(startIndex, endIndex) || [];
        setPageData(newPageData);
    }, [page, regulations]);

    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage - 1); // Adjust for 0-based index
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setExpandAll(event.target.checked);
    };

    useEffect(() => {
        setPage(0); // Reset to the first page when the user input vessel page text search
    }, [userInputText]);

    return (
        <>
            {/* Render the paginated data */}
            {pageData && pageData.length > 0 ? (
                <>
                    {/* Top Pagination Controls */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                        <Box flexGrow={1} display="flex" justifyContent="center">
                            <Pagination color="primary" count={Math.ceil((regulations?.length || 0) / rowsPerPage)} page={page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                        </Box>
                        <FormControlLabel control={<Switch checked={expandAll} onChange={handleChange} name="expandAll" />} label="Expand All" />
                    </Stack>

                    {pageData.map((regulation: IRegulation, index: number) => (
                        <RegulationCardsItem key={`${index}-regulation-item`} regulation={regulation} expandAll={expandAll} />
                    ))}

                    {/* Bottom Pagination Controls */}
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'center'}>
                        <Pagination color="primary" count={Math.ceil((regulations?.length || 0) / rowsPerPage)} page={page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                    </Stack>
                </>
            ) : (
                <Typography variant="h6" color={AbsColor.Blue1}>
                    No results found.
                </Typography>
            )}
        </>
    );
};

export default RegulationCards;
